import { useQuery } from "@apollo/client";
import { Box, Text } from "grommet";
import { useEffect, useState } from "react";
import { GET_LATEST_WON_DENY_WAR } from "../../queries/user_queries";

const DenyWarAnnoucement = () => {
  // get latest won war
  const [war, setWar] = useState(null);
  const [now, setNow] = useState(Date.now);
  const { loading, error, data, startPolling } = useQuery(
    GET_LATEST_WON_DENY_WAR
  );

  useEffect(() => {
    startPolling(4000);
  }, []);

  useEffect(() => {
    if (data?.getLatestWonDenyWar) {
      setWar(data.getLatestWonDenyWar);
    }
  }, [data]);
  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now); // Update state with the current date
    }, 1000);

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, []);
  if (war === null) {
    return <></>;
  }

  const { endDate, denies, undenies, undenyLeader, denyLeader, winner } = war;
  // Get the current time in milliseconds

  // Check if the timestamp is earlier than 60 seconds ago
  const sixtySecondsAgo = now - 60 * 1000; // 60 seconds in milliseconds
  if (endDate < sixtySecondsAgo) {
    return <></>;
  }
  const isDenywin = winner === 1;
  return (
    <Box
      background={isDenywin ? "status-critical" : "status-ok"}
      justify="center"
      animation={[
        {
          type: "zoomIn",
          duration: 2000,
          size: "xlarge",
          delay: 500,
        },
      ]}
      round
    >
      <Box
        alignSelf="center"
        align="center"
        width={"full"}
        border={{ size: "large", side: "bottom", color: "dark-1" }}
      >
        <Text color="light-1">Deny War Results</Text>
      </Box>
      <Box alignSelf="center" margin="medium" animation={"pulse"}>
        <Text size="xlarge" color="light-1" textAlign="center">
          {isDenywin ? "Deny" : "Undeny"} Wins!
        </Text>
      </Box>
      <Box direction="row" wrap justify="around">
        <Box align="center" margin={{ vertical: "small" }}>
          <Text color="light-1">Denies: {denies}</Text>
          <Text color="dark-1" size="large">
            👑{denyLeader}
          </Text>
        </Box>
        <Box align="center" margin={{ vertical: "small" }}>
          <Box>
            <Text color="light-1">Undenies: {undenies}</Text>
          </Box>
          <Text color="dark-1" size="large" truncate>
            👑{undenyLeader}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default DenyWarAnnoucement;
